import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["category", "dimensions", "weight"]

  connect() {
    this.refresh()
  }

  refresh() {
    const packaging = this.categoryTarget.value === "packaging"
    this.dimensionsTarget.hidden = !packaging
    this.dimensionsTarget.querySelectorAll("input").forEach(input => {
      input.disabled = !packaging
      input.required = packaging
    })
    this.weightTarget.required = packaging
    this.weightTarget.min = packaging ? "0.000001" : "0"
  }
}
